// @ts-nocheck
/**
 * Delete-confirmation dialog. Ported to shadcn ConfirmDialog from the
 * previous react-bootstrap version.
 *
 * Props contract preserved:
 *   { show, setShow, setConfirmDelete, userLoadingDelete, isMultiDelete?, clearSelectedData? }
 */
import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';

function RenderDeleteModal(props) {
  const isMulti = !!props.isMultiDelete;

  const onOpenChange = (next) => {
    props.setShow(next);
    if (!next && isMulti && typeof props.clearSelectedData === 'function') {
      props.clearSelectedData();
    }
  };

  return (
    <ConfirmDialog
      open={!!props.show}
      onOpenChange={onOpenChange}
      title={isMulti ? 'Delete selected records?' : 'Delete this record?'}
      description={
        isMulti
          ? 'This will permanently delete every selected record. This action cannot be undone.'
          : 'This will permanently delete the record. This action cannot be undone.'
      }
      confirmLabel="Delete"
      cancelLabel="Cancel"
      tone="destructive"
      loading={!!props.userLoadingDelete}
      onConfirm={() => props.setConfirmDelete(true)}
    />
  );
}

export default RenderDeleteModal;
